import { axiosInstance } from '.'
import { DocumentService, DocumentType } from '../lib/types'

import {
  CREATE_TERMSHEET_SIGNING_LINK,
  GET_DOCUMENT_ACCESS_TOKEN,
  GET_DOCUMENT_DOWNLOAD_LINK,
  GET_DOCUMENT_SIGNING_LINK,
  GET_TERMSHEET_AGREEMENT_TEMPLATE,
} from './endpoints'

export const documentServices: DocumentService = {
  getAccessToken: async (headers: { [key: string]: string }) => {
    try {
      return await axiosInstance.get(GET_DOCUMENT_ACCESS_TOKEN, {
        headers: headers,
      })
    } catch (error: any) {
      return error.response
    }
  },

  getSigningLink: async (
    accessToken: string,
    documentType: DocumentType,
    headers: { [key: string]: string },
    opportunityId?: string,
    clientAgreementServiceType?: 'check1' | 'check2' | 'check3',
  ) => {
    try {
      return await axiosInstance.get(GET_DOCUMENT_SIGNING_LINK, {
        params: {
          accessToken,
          documentType,
          opportunityId,
          clientAgreementServiceType,
        },
        headers: headers,
      })
    } catch (error: any) {
      return error.response
    }
  },

  getDownloadLink: async (
    accessToken: string,
    documentId: string,
    headers: { [key: string]: string },
  ) => {
    try {
      return await axiosInstance.get(GET_DOCUMENT_DOWNLOAD_LINK, {
        params: { accessToken, documentId },
        headers: headers,
      })
    } catch (error: any) {
      return error.response
    }
  },

  getTermsheetAgreementTemplate: async (
    opportunityId: string,
    investmentAmount: string,
    investmentId: string,
    headers: { [key: string]: string },
  ) => {
    try {
      return await axiosInstance.get(
        GET_TERMSHEET_AGREEMENT_TEMPLATE(opportunityId, investmentAmount, investmentId),
        {
          headers: headers,
        },
      )
    } catch (error: any) {
      return error.message
    }
  },

  createTermsheetSigningLink: async (
    opportunityId: string,
    investmentAmount: string,
    investmentId: string,
    headers: { [key: string]: string },
  ) => {
    try {
      return await axiosInstance.post(
        CREATE_TERMSHEET_SIGNING_LINK,
        { opportunityId, investmentAmount, investmentId },
        { headers },
      )
    } catch (error: any) {
      return error.response
    }
  },
}
